<template src="./template.html"></template>

<style scoped lang="scss">
@import "style";
</style>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    transparent: {
      type: Boolean,
      default: false,
    },
    onSelectedPicture: {
      type: Function,
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
    accept: {
      type: String,
      default: "image/png, image/jpeg, image/jpg",
    },
    placeholder: {
      type: String,
      default: "Image",
    },
    prependIcon: {
      type: String,
      default: "fas fa-camera",
    },
    label: {
      type: String,
      default: "",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    validate: {
       type: Function,
    },
  },
  name: "Upload",
  created() {},
  computed: {},
  data() {
    return {};
  },
  methods: {
    selectPicture(files) {
      if (!this.multiple) {
        if(files.length){
          this.onSelectedPicture(files[0]);
        }else {
          this.onSelectedPicture(files);
        }
      } else {
        this.onSelectedPicture(files);
      }
    },
    selectPictureFromInput(event) {
      console.log(event.target.files);
      if (!this.multiple) {
        this.onSelectedPicture(event.target.files[0]);
      } else {
        this.onSelectedPicture(event.target.files);
      }
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
};
</script>
